// https://firebase.google.com/docs/reference/node/firebase.auth.Auth
const firebaseErrorMap: Record<string, string> = {
  'auth/email-already-in-use': 'An account already exists with this email address.',
  'auth/invalid-email': 'The email address is not valid.',
  'auth/weak-password': 'This password is not strong enough.',
  'auth/user-disabled': 'This user has been disabled.',
  'auth/user-not-found': 'There is no user registered with this email.',
  'auth/wrong-password': 'The password is invalid or not set.',
  'auth/unsupported-persistence-type': "Your environment does not support your 'Remember me' setting.",
};

export interface AuthError {
  code: string;
  message: string | undefined;
}

// Maps Firebase Auth's error.code to AuthError with a human readable error message
export const handleFirebaseError = (error: any): AuthError => ({
  code: error.code,
  message: firebaseErrorMap[error.code],
});
